import Autocomplete from "@mui/material/Autocomplete";
import EditorVisualTextField from "developer/edit/components/EditorVisualTextField";

type SpacingFieldProps = {
  name: string;
  value: any;
  onChange: (value: any) => void;
};

const SpacingField = (props: SpacingFieldProps) => {
  return (
    <Autocomplete
      id="size"
      size="small"
      onChange={(event, newValue) => {
        props.onChange(newValue);
      }}
      value={props.value}
      options={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
      fullWidth
      disableClearable
      autoHighlight
      getOptionLabel={(option) => option.toString()}
      isOptionEqualToValue={(option, value) => +option === +value}
      renderInput={(params) => (
        <EditorVisualTextField {...params} name={props.name} label="Spacing" />
      )}
    />
  );
};

export default SpacingField;
